import { format } from 'date-fns'
import dateFormats from '../constants/date-formats'

function toUTCMidnight(date: Date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0))
}

function toLocalDateString(date: Date): string {
  return format(date, dateFormats.basicReadable)
}

const DateHelper = {
  toUTCMidnight,
  toLocalDateString,
}

export default DateHelper
